
{
  "descriptions": {
    "non-actionable": "We tried our best, but something went wrong. We couldn’t publish all of your changes.",
    "actionable": "We tried our best, but something went wrong. We found a few issues. Here’s what you need to check:"
  }
}
